// เขียนยอดซื้อประกันสุขภาพลง key ของสุขภาพเท่านั้น พร้อมคืนสถานะเกินสิทธิ์โดยไม่แก้ object ต้นฉบับ
export const createHealthInsurancePlanChange = ({
  currentState = {},
  value,
  remainingAllowance,
}) => {
  return {
    nextState: {
      ...currentState,
      tax_plan_insurance_health: value,
    },
    hasError: value > remainingAllowance,
  };
};
